import React, { useMemo } from "react";
import Select, { components } from "react-select";

const BankTransfersTripSelect = ({
    value,
    valueName,
    trips = [],
    onChange,
    onMenuOpen,
    isLoadingTrips = false,
    isSaving = false
}) => {
    const options = useMemo(() => [
        {
            value: null,
            label: "Bez przypisania",
            isEmpty: true
        },
        ...trips.map((trip) => ({
            value: trip.id,
            label: trip.name,
            trip
        }))
    ], [trips]);

    const selectedOption = useMemo(() => {
        if (value == null)
            return null;

        const option = options.find(
            (option) => option.value === value
        );

        if (option)
            return option;

        if (valueName) {
            return {
                value,
                label: valueName
            };
        }

        return null;
    }, [options, value, valueName]);

    const SingleValue = (props) => (
        <components.SingleValue {...props}>
            <span
                className="bank-transfer-trip-selected-value"
                title={props.data.label}
            >
                {props.data.label}
            </span>
        </components.SingleValue>
    );

    const Option = (props) => (
        <components.Option {...props}>
            <div
                className={
                    props.data.isEmpty
                        ? "bank-transfer-trip-select-option-empty"
                        : "bank-transfer-trip-select-option"
                }
            >
                {props.data.isEmpty && (
                    <span className="bank-transfer-trip-select-option-empty-icon">
                        ×
                    </span>
                )}

                <span>
                    {props.data.label}
                </span>
            </div>
        </components.Option>
    );

    const MenuList = (props) => {
        if (isLoadingTrips) {
            return (
                <div className="bank-transfer-trip-loading">
                    <div className="bank-transfer-trip-loading-spinner" />

                    <span>
                        Pobieranie wycieczek...
                    </span>
                </div>
            );
        }

        return (
            <components.MenuList {...props}>
                {props.children}
            </components.MenuList>
        );
    };

    const NoOptionsMessage = (props) => (
        <components.NoOptionsMessage {...props}>
            <div className="bank-transfer-trip-no-options">
                Nie znaleziono wycieczki
            </div>
        </components.NoOptionsMessage>
    );

    return (
        <div
            className="bank-transfer-trip-react-select"
            onClick={(e) => e.stopPropagation()}
        >
            <Select
                options={options}
                value={selectedOption}
                onChange={(option) =>
                    onChange(option?.value ?? null)
                }
                onMenuOpen={onMenuOpen}
                isSearchable
                isClearable={false}
                isDisabled={isSaving}
                placeholder="+ Przypisz"
                noOptionsMessage={() => "Nie znaleziono wycieczki"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                components={{
                    SingleValue,
                    Option,
                    MenuList,
                    NoOptionsMessage,
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null
                }}
                classNamePrefix="bank-trip-select"
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                    })
                }}
            />
        </div>
    );
};

export default BankTransfersTripSelect;